import httpClient from "../axiosBase/axiosHandler";

export const getWaybills = (queries) => {
  return httpClient.get(`/waybills/${queries}`);
};

export const getPurchaseOrders = (queries = "", queryParams = {}) => {
  return httpClient.get(`/purchase-order/${queries}`, {
    params: { ...queryParams },
  });
};

export const createPO = (data) => {
  return httpClient.post("/purchase-order/", data);
};

export const getPurchaseOrderDetails = (id) => {
  return httpClient.get(`/purchase-order/${id}/`);
};

export const updatePurchaseOrder = ({ id, data }) => {
  return httpClient.patch(`/purchase-order/${id}/`, data);
};

export const deletePurchaseOrder = (id) => {
  return httpClient.delete(`/purchase-order/${id}/`);
};

export const getPurchaseOrderItems = (id) => {
  return httpClient.get(`/purchase-order/${id}/product-list/`);
};

export const approveOrRejectPO = ({ id, data }) => {
  return httpClient.patch(
    `/purchase-order/${id}/update-po-order-status/`,
    data,
  );
};

export const openOrClosePO = ({ id, data }) => {
  return httpClient.patch(
    `/purchase-order/${id}/update-po-order-status/`,
    data,
  );
};

export const updatePOSupplier = ({ id, data }) => {
  return httpClient.patch(`/purchase-order/${id}/change-supplier/`, data);
};

export const getPOCategories = (queries) => {
  return httpClient.get(`/purchase-order-categories/${queries}`);
};

export const downloadPO = ({ id }) => {
  return httpClient.post(`/purchase-order/${id}/generate-po-pdf/`, {});
};

export const sendPOEmail = ({ id, data }) => {
  return httpClient.post(`/purchase-order/${id}/send-to-supplier/`, data);
};

export const deletePO = ({ id }) => {
  return httpClient.delete(`/purchase-order/${id}/`, {});
};

export const updateFulfillmentPO = ({ id, data }) => {
  return httpClient.patch(
    `/purchase-order/${id}/update-po-order-fulfillment-state/`,
    data,
  );
};

export const updatePricingViaPO = ({ id, data }) => {
  return httpClient.patch(
    `/purchase-order/${id}/bulk-update-selling-price/`,
    data,
  );
};

export const createGoodsReceived = (data) => {
  return httpClient.post("/goods-received/", data);
};

export const updateGoodsReceived = ({ id, data }) => {
  return httpClient.patch(`/goods-received/${id}/`, data);
};

export const getGoodsReceived = (queries) => {
  return httpClient.get(`/goods-received/${queries}`);
};

export const getGoodsReceivedDetails = (id) => {
  return httpClient.get(`/goods-received/${id}/`);
};

export const getGoodsReceivedItems = (id) => {
  return httpClient.get(`/goods-received/${id}/product-list/`);
};

export const deleteGoodsReceived = ({ id }) => {
  return httpClient.delete(`/goods-received/${id}/`);
};

export const approveOrRejectGR = ({ id, data }) => {
  return httpClient.patch(`/goods-received/${id}/update-gr-status/`, data);
};

export const downloadGR = ({ id }) => {
  return httpClient.post(`/goods-received/${id}/generate-gr-pdf/`, {});
};

export const createBills = (data) => {
  return httpClient.post("/bills/", data);
};

export const updateBills = ({ id, data }) => {
  return httpClient.patch(`/bills/${id}/`, data);
};

export const getBills = (queries) => {
  return httpClient.get(`/bills/${queries}`);
};

export const getBillsDetails = (id) => {
  return httpClient.get(`/bills/${id}/`);
};

export const getBillsItems = (id) => {
  return httpClient.get(`/bills/${id}/item-list/`);
};

export const deleteBills = ({ id }) => {
  return httpClient.delete(`/bills/${id}/`);
};

export const approveOrRejectBills = ({ id, data }) => {
  return httpClient.patch(`/bills/${id}/update-bill-status/`, data);
};

export const downloadBills = ({ id }) => {
  return httpClient.post(`/bills/${id}/generate-bill-pdf/`, {});
};

export const sendBillsToSupplier = ({ id }) => {
  return httpClient.post(`/bills/${id}/send-to-suppliers/`, {});
};

export const createPOCategory = (data) => {
  return httpClient.post("/purchase-order-categories/", data);
};

export const updatePOCategory = ({ id, data }) => {
  return httpClient.patch(`/purchase-order-categories/${id}/`, data);
};

export const deletePOCategory = ({ id }) => {
  return httpClient.delete(`/purchase-order-categories/${id}/`);
};
